import axios from 'axios';
import { from } from 'rxjs';

export const sendNotifications = (fulfillmentPlanIds) =>
  from(axios.post('/fulfillmentPlan/notifications/send', { fulfillmentPlanIds }).then((response) => response.data));

export const retryNotifications = (fulfillmentPlanIds) =>
  from(axios.post('/fulfillmentPlan/notifications/retry', { fulfillmentPlanIds }).then((response) => response.data));

export const retryNotificationsPromise = (fulfillmentPlanIds) => axios.post('/fulfillmentPlan/notifications/retry', { fulfillmentPlanIds });
